export const MIN_RELATIVE_VALUE = 1;
export const MAX_RELATIVE_VALUE = 999;
export const DEFAULT_RELATIVE_VALUE = 1;

/** Clamps to [MIN, MAX] and truncates fractions. Returns null for null/undefined/non-finite. */
export const clampRelativeValue = (value: number | null | undefined): number | null => {
  if (value == null || !Number.isFinite(value)) return null;
  const truncated = Math.trunc(value);
  if (truncated < MIN_RELATIVE_VALUE) return MIN_RELATIVE_VALUE;
  if (truncated > MAX_RELATIVE_VALUE) return MAX_RELATIVE_VALUE;
  return truncated;
};
